export default __webpack_public_path__ + "static/media/listMoreIcon.d3fcae91.svg";